<template>

</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'LiveSession',
  computed: {
    user() {
      return this.$store.getters['auth/user'];
    },
  },
  created() {

    if (import.meta.env.VITE_APP_ENV === 'local') {
      return;
    }

    window['__ls_namespace'] = '__ls';
    window['__ls_script_url'] = 'https://cdn.livesession.io/track.js';
    !function(w, d, t, u, n) {
      if (n in w) {if(w.console && w.console.log) { w.console.log('LiveSession namespace conflict. Please set window["__ls_namespace"].');} return;}
      if (w[n]) return; var f = w[n] = function() { f.push ? f.push.apply(f, arguments) : f.store.push(arguments)};
      if (!w[n]) w[n] = f; f.store = []; f.v = "1.1";

      var ls = d.createElement(t); ls.async = true; ls.src = u;
      var s = d.getElementsByTagName(t)[0]; s.parentNode.insertBefore(ls, s);
    }(window, document, 'script', window['__ls_script_url'], window['__ls_namespace']);

    if (window.__ls) {
        window.__ls("init", "352f8547.2282af1e", { keystrokes: false });
        window.__ls("newPageView");
    }
  },
  data() {
    return {
      identified: false,
    };
  },
  watch: {
    user: {
      immediate: true,
      handler() {

        if (this.user && !this.identified && window.__ls) {

          window.__ls("identify", {
            id: this.user.id,
            name: this.user.fullName,
            email: this.user.email,
          });

          this.identified = true;
        }
      },
    },
  }
})
</script>

<style scoped lang="scss">

</style>
